module.exports = __webpack_public_path__ + "img/timesaas-intro.3368ed81.png";